import { objEqual } from "./tools";
import { routes,route404,homeRoute,headMenu } from "@/router/routes"
import config from '@/config/base-config'
import layout from '@/components/layout/layout.vue'
import AuthRoute from "@/router/auth";

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
export const getArrayFromFile = (file) => {
  let nameSplit = file.name.split('.')
  let format = nameSplit[nameSplit.length - 1]
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsText(file) // 以文本格式读取
    let arr = []
    reader.onload = function (evt) {
      let data = evt.target.result // 读到的数据
      let pasteData = data.trim()
      arr = pasteData.split((/[\n\u0085\u2028\u2029]|\r\n?/g)).map(row => {
        return row.split('\t')
      }).map(item => {
        return item[0].split(',')
      })
      if (format === 'csv') resolve(arr)
      else reject(new Error('[Format Error]:你上传的不是Csv文件'))
    }
  })
}

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
export const getTableDataFromArray = (array) => {
  let columns = []
  let tableData = []
  if (array.length > 1) {
    let titles = array.shift()
    columns = titles.map(item => {
      return {
        title: item,
        key: item
      }
    })
    tableData = array.map(item => {
      let res = {}
      item.forEach((col, i) => {
        res[titles[i]] = col
      })
      return res
    })
  }
  return {
    columns,
    tableData
  }
}

/**
 * 获取目录列表，去掉不需要展示的目录
 * @param lists
 * @returns {[]}
 */
export const getMenuLists = () => {
  let menuLists = JSON.parse(sessionStorage.getItem('menuLists'))

  return menuLists.filter( val => {
    return !(val.meta && val.meta.hideInMenu)
  })
}

export const setToken = (token) => {
  sessionStorage.setItem('token',token)
}

export const getToken = () => {
  return sessionStorage.getItem('token')
}

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}

/**
 * 判断打开的标签列表里是否已存在要操作的路由对象
 * @param openedPage 打开页面列表
 * @param routeItem  当前打开的路由
 */
export const routeHasExist = (openedPage, routeItem) => {
  let res = false
  openedPage.forEach(function (val,key) {
    if (routeEqual(val, routeItem)) res = true
  })
  return  res;
}

//退出登录，清除token和menu
export const loginOut = () => {
  sessionStorage.clear()
  // sessionStorage.removeItem('menuLists')
  // sessionStorage.removeItem('token')
}

//根据后台返回用户的权限设置菜单目录， 动态添加路由,并将路由信息缓存起来
export const dealAuthRoute = (newAuthRoute, { routerInstance, storeInstance } = {}) => {
  const router = routerInstance
  const store = storeInstance
  if (!router || !store) {
    throw new Error('dealAuthRoute requires routerInstance and storeInstance')
  }
  let key = config.AUTH_ROUTE_KEY,authRoute=newAuthRoute || AuthRoute();

  // 根据用户组ID设置默认首页
  const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
  const defaultHomePath = groupID === 3 ? '/dashboard' : '/home';
  
  // 合伙人不添加 homeRoute，只使用 dashboard
  const childrenRoutes = groupID === 3 ? [...authRoute] : [homeRoute, ...authRoute];
  
  // 构建动态根路由
  const dynamicRootRoute = {
    path: '/',
    name: '',
    redirect: defaultHomePath,
    component: layout,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: childrenRoutes
  };
  
  // 替换 routes 中的静态根路由为动态根路由
  const filteredRoutes = routes.filter(route => route.path !== '/');
  let menuLists = [...filteredRoutes, dynamicRootRoute, ...authRoute, ...route404, ...headMenu];
  sessionStorage.setItem('menuLists',JSON.stringify(menuLists))
  store.commit('app/setIsAddRoute')
  
  authRoute = [dynamicRootRoute]
  // 正确添加路由
  authRoute.forEach(route => router.addRoute(route))
  if (Array.isArray(headMenu)) {
    headMenu.forEach(route => router.addRoute(route))
  } else {
    router.addRoute(headMenu)
  }
  if (Array.isArray(route404)) {
    route404.forEach(route => router.addRoute(route))
  } else {
    router.addRoute(route404)
  }
}


export const findNodeDownward = (ele, tag) => {
  const tagName = tag.toUpperCase()
  if (ele.childNodes.length) {
    let i = -1
    let len = ele.childNodes.length
    while (++i < len) {
      let child = ele.childNodes[i]
      if (child.tagName === tagName) return child
      else return findNodeDownward(child, tag)
    }
  }
}

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}


